import { render, staticRenderFns } from "./jackpot-fake.vue?vue&type=template&id=7ecf3a14"
import script from "./jackpot-fake.vue?vue&type=script&lang=js"
export * from "./jackpot-fake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/jackpots/jackpot-fake/jackpot-fake.vue
// module id = fkZx
// module chunks = 0